import CardPayment from './CardPayment';

export default CardPayment;
